import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import React__default, { useCallback } from 'react';
import MuiPopover from '@mui/material/Popover';
import MuiPaper from '@mui/material/Paper';
import { ClickAwayListener } from '@mui/material';
import { ReactComponent as ForwardRef } from '../../../../../assets/icons/FilterMedium.svg.js';

const StyledFilterColumnIcon = styled(ForwardRef) `
  cursor: pointer;
  margin: ${({ theme }) => theme.spacing(0, 2)};
  > path {
    fill: ${({ theme }) => theme.palette.primary.main};
  }
`;
const FilterIcon = (props) => (jsx(StyledFilterColumnIcon, Object.assign({ "data-testid": "filter-icon", className: "filter-icon" }, props)));
const StyledPopover = styled(MuiPopover) `
  height: 150px;
  > div {
    overflow: hidden;
    max-height: 200px;
  }
`;
const PopupRoot = styled(MuiPaper) `
  display: inline-block;
  background-color: ${({ theme }) => theme.palette.N70.main};
  padding: ${({ theme }) => theme.spacing(2)};
  width: 200px;
`;
const FilterPopover = ({ children, rtl }) => {
    const [anchorEl, setFilterAnchorEl] = React__default.useState(null);
    const openFilter = useCallback((e) => {
        e.stopPropagation();
        setFilterAnchorEl(e.target);
    }, []);
    const closeFilter = useCallback((e) => {
        e.stopPropagation();
        setFilterAnchorEl(null);
    }, []);
    return (jsxs(Fragment, { children: [jsx(FilterIcon, { onClick: openFilter }), jsx(ClickAwayListener, Object.assign({ onClickAway: closeFilter }, { children: jsx(StyledPopover, Object.assign({ open: Boolean(anchorEl), anchorEl: anchorEl, onClose: closeFilter, onClick: e => e.stopPropagation(), anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: rtl ? 'left' : 'right',
                    }, transformOrigin: { vertical: 'top', horizontal: rtl ? 'right' : 'left' } }, { children: jsx(PopupRoot, Object.assign({ elevation: 0 }, { children: children })) })) }))] }));
};

export { FilterIcon, FilterPopover, PopupRoot, FilterPopover as default };
//# sourceMappingURL=FilterPopover.js.map
